export interface SubmitRefusal {
  message: string;
  isTerminal: boolean;
}

const UNEXPECTED: SubmitRefusal = {
  message:
    "We couldn't complete your check-in. Please see the meeting clerk for help.",
  isTerminal: false
};

const BY_CODE: Record<string, string> = {
  "CheckIn.AtCapacity":
    "This meeting has reached its in-person registration limit. Please see the meeting clerk.",
  "CheckIn.SpeakerCapacity":
    "The speaker list for this meeting is full, so your speaking requests could not be saved.",
  "CheckIn.RegistrationDisabled":
    "Registration isn't available for this meeting.",
  "CheckIn.RegistrationNotYetOpen":
    "Registration for this meeting hasn't opened yet.",
  "CheckIn.RegistrationClosedBeforeMeeting":
    "Registration for this meeting has closed.",
  "CheckIn.MeetingEnded": "This meeting has ended, so registration is closed.",
  "CheckIn.RegistrationClosed": "Registration for this meeting is closed."
};

export function submitRefusalMessage(refusal: {
  code?: string | null;
  isPolicyRefusal?: boolean;
}): SubmitRefusal {
  if (!refusal.isPolicyRefusal) return UNEXPECTED;

  const message = refusal.code ? BY_CODE[refusal.code] : undefined;
  if (!message) return UNEXPECTED;

  return { message, isTerminal: true };
}
